import { atom } from 'jotai';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { getTLD } from '~/lib/utils';
import { store } from '~/store';

export const AUTH_COOKIE_NAME = 'auth_token';
export const REFRESH_COOKIE_NAME = 'refresh_token';
const AUTH_COOKIE_TTL = 1000 * 60 * 60 * 24 * 365;

export const authorizedAtom = atom(false);
export const authorizationPendingAtom = atom(true);

export function setAuthData(token: string, refreshToken?: string | null) {
  const decoded = jwtDecode(token);

  if (!decoded) {
    return;
  }

  // important: set domain-wise cookie!!
  Cookies.set(AUTH_COOKIE_NAME, token, {
    expires: new Date(Date.now() + AUTH_COOKIE_TTL),
    domain: `.${getTLD()}`,
    sameSite: 'none',
    secure: true,
  });

  if (refreshToken) {
    const decodedRefresh = jwtDecode(refreshToken);

    if (decodedRefresh.exp) {
      Cookies.set(REFRESH_COOKIE_NAME, refreshToken, {
        expires: new Date(decodedRefresh.exp * 1000),
        domain: `.${getTLD()}`,
        sameSite: 'none',
        secure: true,
      });
    }
  }
}

export function checkAuth() {
  store.set(authorizationPendingAtom, () => true);

  const authToken = Cookies.get(AUTH_COOKIE_NAME);

  if (!authToken) {
    store.set(authorizationPendingAtom, () => false);

    return false;
  }

  try {
    jwtDecode(authToken);

    store.set(authorizedAtom, () => true);
  } catch (error) {
    console.error(error);

    return false;
  } finally {
    store.set(authorizationPendingAtom, () => false);
  }

  return true;
}

export function signOut() {
  Cookies.remove(AUTH_COOKIE_NAME, { domain: `.${getTLD()}`, sameSite: 'none', secure: true });
  Cookies.remove(REFRESH_COOKIE_NAME, { domain: `.${getTLD()}`, sameSite: 'none', secure: true });

  store.set(authorizedAtom, () => false);
  store.set(authorizationPendingAtom, () => false);

  if (typeof window.__PXBROWSER__ !== 'undefined' && window.__PXBROWSER__.deviceType === 'mobile') {
    window.location.href = `${window.__PXBROWSER__.app}browser://navigation/hometabs/dashboard?closeThisTab=true`;
    return;
  }

  window.location.href = window.__CONFIG.VITE_DASHBOARD_URL;
}
